export default __webpack_public_path__ + "static/media/bsiLogo.f4abd8f3.svg";